import { render } from "./ProductRelatedManual.vue?vue&type=template&id=4d607fb4"
import script from "./ProductRelatedManual.vue?vue&type=script&lang=js"
export * from "./ProductRelatedManual.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__